import { j as s } from "./utils-BdNIfrGQ.js";
import { D as w } from "./Div-spVpsZsH.js";
import { D as f } from "./Div.skeleton-DLnqOZrU.js";
import { F as i } from "./Flex-BA9xHq_p.js";
import "./Grid-DJGISvmf.js";
import { useMemo as z } from "react";
import "./NavLink-D9Qfouy1.js";
import { E as d } from "./ExternalLink-CwLUkrFF.js";
import "./HamburgerMenu-Bi4wrZqX.js";
import v from "./components/avatar/Avatar.mjs";
import { T as u } from "./ThumbnailImage-CQfW_Fzc.js";
import { u as M } from "./ResponsiveProvider-C06ERneB.js";
import { H as j } from "./H2-CGvOaVnq.js";
import { P as h } from "./Paragraph-Cpgi01iq.js";
import { c as N } from "./createLucideIcon-D4r5Phnh.js";
const S = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], b = N("calendar", S);
const D = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], y = N("map-pin", D), I = ({ logo: e, avatar: a, landingPageUrl: t }) => {
  const { isMobile: r } = M(), n = r ? "md" : "lg", l = r ? "size-[56px]" : "sm:size-[72px]";
  return e ? /* @__PURE__ */ s.jsx(i, { className: "bg-transparent self-start flex-shrink-0 h-fit", children: t ? /* @__PURE__ */ s.jsx(d, { href: t, children: /* @__PURE__ */ s.jsx(u, { src: e.src, alt: e.alt, size: n }) }) : /* @__PURE__ */ s.jsx(u, { src: e.src, alt: e.alt, size: n }) }) : a ? /* @__PURE__ */ s.jsx(i, { className: `bg-transparent self-start flex-shrink-0 ${l}`, children: /* @__PURE__ */ s.jsx(v, { profileImage: a.profileImage, fallback: a.fallback, size: "full" }) }) : /* @__PURE__ */ s.jsx(s.Fragment, {});
}, W = ({
  name: e,
  description: a,
  dateConfig: t,
  location: r,
  locationUrl: n,
  landingPageUrl: l,
  media: m
}) => {
  const c = z(() => {
    if (t) {
      const { dates: o, format: x } = t, [g, k] = o;
      return x ? k ? x.formatRange(g, k) : x.format(g) : o.filter((p) => !!p).map((p) => p.toISOString()).join(" - ");
    }
  }, [t]);
  return /* @__PURE__ */ s.jsxs(i, { gap: "4", className: "flex-col", children: [
    l ? /* @__PURE__ */ s.jsx(d, { href: l, children: /* @__PURE__ */ s.jsx(j, { align: "left", size: "3xl", children: e }) }) : /* @__PURE__ */ s.jsx(j, { align: "left", size: "3xl", children: e }),
    m,
    a && /* @__PURE__ */ s.jsx(w, { className: "text-muted-foreground sm:max-w-[400px]", children: /* @__PURE__ */ s.jsx(h, { align: "left", children: a }) }),
    (t || r) && /* @__PURE__ */ s.jsxs(
      i,
      {
        gap: "0 5",
        className: "text-muted-foreground text-sm flex-row flex-wrap items-start justify-start",
        children: [
          t && /* @__PURE__ */ s.jsxs(h, { type: "inline", align: "left", children: [
            /* @__PURE__ */ s.jsx(
              b,
              {
                size: 14,
                strokeWidth: 2,
                className: "mr-4 mt-2 flex-shrink-0",
                "data-testid": "calendar-icon"
              }
            ),
            c
          ] }),
          r && (n ? /* @__PURE__ */ s.jsxs(d, { href: n, variant: "inline", children: [
            /* @__PURE__ */ s.jsx(
              y,
              {
                size: 14,
                strokeWidth: 2,
                className: "mr-4 mt-2 flex-shrink-0",
                "data-testid": "map-pin-icon"
              }
            ),
            r
          ] }) : /* @__PURE__ */ s.jsxs(h, { type: "inline", align: "left", children: [
            /* @__PURE__ */ s.jsx(
              y,
              {
                size: 14,
                strokeWidth: 2,
                className: "mr-4 mt-2 flex-shrink-0",
                "data-testid": "map-pin-icon"
              }
            ),
            r
          ] }))
        ]
      }
    )
  ] });
}, G = ({
  name: e,
  logo: a,
  avatar: t,
  dateConfig: r,
  location: n,
  locationUrl: l,
  landingPageUrl: m,
  description: c,
  media: o
}) => /* @__PURE__ */ s.jsxs(i, { className: "flex-row flex-grow gap-y-6 gap-x-6 sm:gap-x-7", children: [
  /* @__PURE__ */ s.jsx(I, { logo: a, avatar: t, landingPageUrl: m }),
  /* @__PURE__ */ s.jsx(
    W,
    {
      name: e,
      description: c,
      dateConfig: r,
      location: n,
      locationUrl: l,
      landingPageUrl: m,
      media: o
    }
  )
] }), J = ({ name: e }) => /* @__PURE__ */ s.jsxs(i, { gap: "3 5", className: "align-top flex-grow flex-row items-start", spacing: "3 5 4", children: [
  /* @__PURE__ */ s.jsx(
    f,
    {
      grayVariant: 300,
      className: "w-[62px] h-[62px] md:w-[72px] md:h-[72px] flex-shrink-0"
    }
  ),
  /* @__PURE__ */ s.jsxs(i, { gap: "4", className: "flex-col items-start", children: [
    e && /* @__PURE__ */ s.jsx(j, { fontWeight: "body", children: e }),
    !e && /* @__PURE__ */ s.jsx(f, { grayVariant: 300, className: "h-7 w-[200px]" }),
    /* @__PURE__ */ s.jsx(
      i,
      {
        gap: "0 5",
        className: "flex-row flex-wrap items-start",
        "data-testid": "content-skeleton",
        children: /* @__PURE__ */ s.jsx(f, { grayVariant: 300, className: "h-10 w-[200px]" })
      }
    )
  ] })
] });
export {
  G as P,
  J as a
};
